 $( document ).ready(function() {
    var menu_v = $(".cstm_prd_v option:selected").attr("data-variant-title");
    var menu_i = $(".cstm_prd_v option:selected").attr("data-variant-image");
    var avail = $(".cstm_prd_v option:selected").attr("data-variant-avail"); 
    var weight = $(".cstm_prd_v option:selected").attr("data-variant-weight");
    var prd_ttl = $(".prds_ttl").text();
    // alert(menu_v);
      
      $(".product-reminder-size").text(menu_v);
      $("img.variant_img").attr("src",menu_i);
      if (avail == "true"){
      $(".vrnt_btn").text("Buy Now");
      $(".new_atc").css("display","block");
      $(".new_buynow").css("display","block");
      $(".bis_cstm").css("display","none");  
      }else
      {  
      $(".unavlble_ntc").text("Sorry, "+ prd_ttl +" "+ menu_v +" is not available right now");
      $(".unavlble_ntc").css("color","red"); 
      console.log("Sorry, "+ prd_ttl +" "+ menu_v +" is not available right now");  
      $(".vrnt_btn").text("Sold Out");
      $(".new_atc").css("display","none");
      $(".new_buynow").css("display","none");  
      }
      $(".prd_wght p").text(weight);

      // Quick View Weight and class add_remove
      $("body").on("click",".quickbuy-toggle",function(){
        $(".quickbuy-container").addClass("new_qv_container");
        setTimeout(function () {          
          var weight_qv = $(".quickbuy-container .cstm_prd_v option:selected").attr("data-variant-weight");
          $(".prd_qv_wght p").text(weight_qv);
        },2000);
      });

     $("body").on("change",".quickbuy-container .option-selector__btns",function(){
         setTimeout(function () {
        $(".quickbuy-container .cstm_prd_v").each(function(){
         var weight_qv_new = $(this).find(":selected").attr("data-variant-weight");
         $(".prd_qv_wght p").text(weight_qv_new);          
         }); }, 1000);
      });
     $(".close-detail").click(function(){
       // alert("close");
       setTimeout(function () {
       if($(".quickbuy-container").hasClass("new_qv_container")){
          $(".quickbuy-container").removeClass("new_qv_container");
         }
         }, 500);
      });    
      // end
      // main product weight 
      $("body").on("change",".section-main-product .option-selector__btns",function(){
         setTimeout(function () {
            $(".section-main-product .cstm_prd_v").each(function(){
              var weight_new = $(this).find(":selected").attr("data-variant-weight");
              $(".prd_wght p").text(weight_new);        
           }); }, 1000);
       });
      // end
    
      $("body").on("change",".option-selector__btns",function(){
            setTimeout(function () {
            $(".unavlble_ntc").css("display","none");  
            $(".cstm_prd_v").each(function(){       
              // var weight_new = $(this).find(":selected").attr("data-variant-weight");
              // $(".prd_wght p").text(weight_new);
              
              var menu_v_new = $(this).find(":selected").attr("data-variant-title");
              if(menu_v_new == undefined){
                var opt_ttl_sticky = "";
                var flag_sticky = parseInt($(".option-selector-fieldset").length);
                $(".option-selector-fieldset").each(function(){
                  if(flag_sticky==1){
                    opt_ttl_sticky =  opt_ttl_sticky + $(this).find('input[type="radio"]:checked').attr("value");
                  }else{     
                    opt_ttl_sticky =  opt_ttl_sticky + $(this).find('input[type="radio"]:checked').attr("value")+" / ";
                    flag_sticky = flag_sticky-1;
                  }
                });
                $(".product-reminder-size").text(opt_ttl_sticky);
              }else{
                $(".product-reminder-size").text(menu_v_new);
              }  
              // alert(menu_v_new);
  
              var menu_i_new = $(this).find(":selected").attr("data-variant-image");
              $("img.variant_img").attr("src",menu_i_new);

              var avali_new = $(this).find(":selected").attr("data-variant-avail");
                // console.log(avali_new);
                if (avali_new == "true"){     
                $(".vrnt_btn").text("Buy Now");
                $(".new_atc").css("display","block");
                $(".new_buynow").css("display","block");
                $(".addon_crt_btn").css("display","block");               
                }else
                { 
                   // console.log(menu_v_new);
                  if(menu_v_new == undefined){
                    // console.log($(this));
                    var opt_ttl = "";
                    var flag = parseInt($(".option-selector-fieldset").length);
                    $(".option-selector-fieldset").each(function(){
                      if(flag==1){
                        opt_ttl =  opt_ttl + $(this).find('input[type="radio"]:checked').attr("value");
                      }else{     
                        opt_ttl =  opt_ttl + $(this).find('input[type="radio"]:checked').attr("value")+" / ";
                        flag = flag-1;
                      }
                    });
                    // console.log(opt_ttl);
                    $(".unavlble_ntc").text("Sorry, "+ prd_ttl +" "+ opt_ttl +" is not available right now");
                  }else
                  {
                    $(".unavlble_ntc").text("Sorry, "+ prd_ttl +" "+ menu_v_new +" is not available right now");
                  }  
                $(".unavlble_ntc").css({"display":"block", "color":"red"});  
                // console.log("Sorry, "+ prd_ttl +" "+ menu_v +" is not available right now");
                $(".vrnt_btn").text("Sold Out");
                $(".new_atc").css("display","none");
                $(".new_buynow").css("display","none");
                $(".addon_crt_btn").css("display","none");
                }
            }); }, 1000);
      });
});  

// add on prodcut js
// $(".qty_vrnt").find(".varnt_nam:first").attr('checked',true);  
$("body").on("click",".prd_common",function(){
  var current = $(this);
  console.log(current);
  var prc=$(this).attr("data-var-price");
  var comp_prc=$(this).attr("data-comp-price");
  if(prc != "" || prc != null ){
    $(this).parents(".list_opt").find(".sale_prc").text(prc);
  }
  if(comp_prc != "" || comp_prc != null ){
    $(this).parents(".list_opt").find(".prc_crossed").text(comp_prc);
  }
  if($(this).hasClass("sld_out_v")){
    $(this).next(".sldout_noti").removeClass("hidden");
    $(".new_atc").css("display","none");
    $(".new_buynow").css("display","none");
    $(".addon_crt_btn").css("display","none");
    // $(this).parents(".list_opt").siblings(".add_oncart_pageb_ttn").css("display","none");
    // alert("hi");
   $(this).parent(".rado_wrap").parent('.qty_vrnt').addClass("hasSoldOut");
 }
 else{
   setTimeout(function(){
    var cnt = "no_opt_sel";
    var av_not_flag = "av_found";
    // var variant_prc = $(".v_price").val();
    //  alert(variant_prc);
    // $(".addon_lst li fieldset strong").text(variant_prc); 
    $(".add_on_prd_box").each(function(){
      if($(this).is(":checked") ){ 
        var avil_nt_found = $(this).parent().find(".qty_vrnt input:checked").hasClass("unavlbl");
        if(avil_nt_found){
          $(".new_atc").css("display","none");
          $(".new_buynow").css("display","none");
          $(".addon_crt_btn").css("display","none");
          // $(this).parents(".list_opt").siblings(".add_oncart_pageb_ttn").css("display","none");
          // alert("hello");
          av_not_flag = "not_av_found";
        } 
       cnt = "opt_sel";
      }
    });
    if(cnt=="no_opt_sel" || av_not_flag == "av_found"){
      $(".new_atc").css("display","block");
      $(".new_buynow").css("display","block");
      $(".addon_crt_btn").css("display","block");
      // $(".list_opt").siblings(".add_oncart_pageb_ttn").css("display","block");
      console.log($(this).parents());
    }
    $(this).parent('.rado_wrap').parent('.qty_vrnt').removeClass('hasSoldOut');
    },100);
 }
  $(this).parent(".rado_wrap").siblings(".rado_wrap").children(".sldout_noti").addClass("hidden");
});
  
  //always keep this below of above click function
  //end
$("body").on("click",".add_on_prd_box",function(){ 
  $(this).siblings(".qty_vrnt").toggle();
  var first_soldout_msg_blow = $(this).siblings(".qty_vrnt").find(".unavlbl");
  if(first_soldout_msg_blow.is(":checked")){
    $(this).siblings('.qty_vrnt').addClass("hasSoldOut");
  }
  
  var cnt = "no_opt_sel";
  var av_not_flag = "av_found";
  $(".add_on_prd_box").each(function(){
    if($(this).is(":checked") ){ 
      var avil_nt_found = $(this).parent().find(".qty_vrnt input:checked").hasClass("unavlbl");
      if(avil_nt_found){
        $(".new_atc").css("display","none");
        $(".new_buynow").css("display","none");
        $(".addon_crt_btn").css("display","none");
        // $(this).parents(".list_opt").siblings(".add_oncart_pageb_ttn").css("display","none");
        // alert("hello world");
        console.log($(this));
        av_not_flag = "not_av_found";
      } 
     cnt = "opt_sel";
    }
  });
  if(cnt=="no_opt_sel" || av_not_flag == "av_found"){
    $(".new_atc").css("display","block");
    $(".new_buynow").css("display","block");
    $(".addon_crt_btn").css("display","block");
    // $current.parents(".list_opt").find(".add_oncart_pageb_ttn").css("display","block");
    // alert("world");
  }
});
 
$("body").on("click",".new_atc",function(){

setTimeout(function () {  
  var crt_add_on_data = $(".car_add_onwrap").html();
  $(".cart-summary-addons").append(crt_add_on_data);
}, 3000);
  
//alert("aaa");
var add_p = [];
var obj = {};
// var all_add_on = [];
// var all_add_on_obj = {};  
var $this = $(this);
$this.parents(".product-detail").find( ".addon_lst li" ).each(function() {
  var obj = {};
  
  // var all_add_on_obj = {};
  // var all_prd_ids = $(this).find( ".add_on_prd_box" ).attr("data-addon-id");
  // console.log(all_prd_ids);
  // all_add_on_obj['id'] = all_prd_ids;
  // all_add_on.push(all_add_on_obj);
  // console.log(all_add_on);
  
  var found = $(this).find( ".add_on_prd_box" );
  if( found.prop('checked')){
    var name = $(this).children(".addon_prd_title").text();
     //alert(name);
      //var vr_title = $(this).find(".v_ttl").val();
      //alert(vr_title);
      var prod_id = $(this).find(".varnt_nam:checked").attr("data-var-id");
        var qty=$(this).find(".product_quntity").val();
        //alert(qty);
    obj["quantity"] = qty;
    obj["id"] = prod_id;
    add_p.push(obj);
  }
});
// console.log(add_p);
if(add_p.length > 0){
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {items:add_p},
         dataType: 'json', 
          success: function (data) { 
            console.log("hi");
            var pathname = window.location.pathname;
            // alert(pathname);
            $this.parents(".product-detail").find(".quantity-submit-row__submit .cstm_crt_class").trigger("click");
            setTimeout(function () {
              if(pathname=="/cart"){
                window.location.reload();
              }
              $(".cart-summary-overlay__title").append("<span> + "+add_p.length+" Add on</span>");
             }, 3000); 
         } 
      });
}else{
  console.log("hello");
  var pathname_without_addon = window.location.pathname;
  if(pathname_without_addon =="/cart"){
    $(window).scrollTop(1000);
  } 
  $this.parents(".product-detail").find(".quantity-submit-row__submit .cstm_crt_class").trigger("click");
   setTimeout(function () {              
    if(pathname_without_addon =="/cart"){
        window.location.reload();
      }
    }, 3000); 
}
});

//for buynow button

// $("body").on("click",".tingle-modal-box__content input[type=checkbox]", function(){
// //alert("aaa");
// var v_id = $(".cstm_prd_v option:selected").attr("data_variant_id");
// var prd_qty = $("#quantity").val();
// var add_p_bnw = [{ quantity: prd_qty, id: v_id },];
// var obj = {};
// $( ".addon_lst li" ).each(function() {
//   var obj = {};   
//   var found = $(this).find( ".add_on_prd_box" );
//   if( found.prop('checked')){
//     var name = $(this).children(".addon_prd_title").text();
//      //alert(name);
//       //var vr_title = $(this).find(".v_ttl").val();
//       //alert(vr_title);
//       var prod_id = $(this).find(".varnt_nam:checked").attr("id");
//         var qty=$(this).find(".product_quntity").val();
//         //alert(qty);
//     obj["quantity"] = qty;
//     obj["id"] = prod_id;
//     add_p_bnw.push(obj);
//   }
// });
// //console.log(add_p_bnw);
// if(add_p_bnw.length > 1){
//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {items:add_p_bnw},
//          dataType: 'json', 
//           success: function (data) { 
//             console.log("hi");            
//             window.location.href = "/checkout";
//             //$(".shopify-payment-button__button").trigger("click");
//          } 
//       });
// }else{
//   $(".shopify-payment-button__button").trigger("click");
// }
// });


// cart pop up add on
$("body").on( "click", ".addon_crt_btn", function(){
var add_cart_p = [];
var obj_cart = {}; 
var $this = $(this);
$(".cart-summary-addons").find( "li" ).each(function() {
  var obj_cart = {};  
  var found_in_cart = $(this).find( ".add_on_prd_box" );
  if( found_in_cart.prop('checked')){
    var name_in_cart = $(this).children(".addon_prd_title").text();
     //alert(name);
      //var vr_title = $(this).find(".v_ttl").val();
      //alert(vr_title);
      var prod_cart_id = $(this).find(".varnt_nam:checked").attr("data-var-id");
        var qty_cart=$(this).find(".product_quntity").val();
        //alert(qty);
    obj_cart["quantity"] = qty_cart;
    obj_cart["id"] = prod_cart_id;
    add_cart_p.push(obj_cart);
  }
});
console.log(add_cart_p);
if(add_cart_p.length > 0){
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {items:add_cart_p},
         dataType: 'json', 
          success: function (data) { 
            console.log("hi");
            // var pathname = window.location.pathname;
            // alert(pathname);
            setTimeout(function () {
                window.location="/cart";
             }, 3000); 
         } 
      });
}else{
  console.log("hello");
}  
})
// Hide Add button if all check boxes are unchecked
$("body").on("change",".addon_lst li",function(){ 
  var box_length =  $(this).parent("ul").find(".add_on_prd_box:checked").length;
    if (box_length==0) {
      $(".addon_crt_btn").css("display","none");
    }else
    {
      $(".addon_crt_btn").css("display","block");        
    }    
});

// Open external link into new window
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}